import './quote-accommodation.scss';

import { Outlet } from "react-router-dom";

import { FilterQuoteAccommodationProvider } from "./filter-quote-accommodation/filter-quote-accommodation.context";

export function QuoteAccommodation() {
  return (
    <div id="ShellQuoteAccommodation" className="quote-accommodation">
       <FilterQuoteAccommodationProvider>
        <Outlet />
      </FilterQuoteAccommodationProvider>
    </div>
  );
}

export default QuoteAccommodation;
